/*
  Enterprise server spec and the one-line install command, shown on the
  Self-hosted page. Keep in step with backend/install/install.sh (its checks
  refuse less than 2 cores / 4 GB / 30 GB and warn below 4 cores / 8 GB) and
  docs/INSTALL.md.
*/

export const SERVER_SPEC = [
  { label: 'Operating system', value: 'Ubuntu 22.04 / 24.04 or Debian 12, x86-64' },
  { label: 'CPU', value: '4 cores (2 at least)' },
  { label: 'RAM', value: '8 GB (4 GB at least)' },
  { label: 'Disk space', value: '50 GB SSD (30 GB free at least)' },
  { label: 'Connection', value: 'Public IP address, ports 80 and 443 open' },
];

export const AFTER_INSTALL = [
  ['xpnsr status', 'Server state and licence'],
  ['xpnsr update', 'Upgrade to the newest signed release'],
  ['xpnsr backup', 'Back up the database to /var/backups/xpnsr'],
];

// XPNSR-XXXXX-... with the brand prefix of the customer's key.
export function keyPlaceholder(hint) {
  const match = /^[A-Z]+/.exec(String(hint || ''));
  const prefix = match ? match[0] : 'XPNSR';
  return [prefix, 'XXXXX', 'XXXXX', 'XXXXX', 'XXXXX', 'XXXXX', 'XXXXX'].join('-');
}

export function installCommand({ base, key, email, role }) {
  const lines = [
    'curl -fsSL ' + base + '/install.sh | sudo bash -s -- \\',
    '  --key ' + key + ' \\',
    '  --email ' + email,
  ];
  if (role === 'test') {
    lines[2] += ' \\';
    lines.push('  --role test');
  }
  return lines.join('\n');
}
